import React from "react";
import styled from "styled-components";

const TAB_HOVER_COLOR = "#F7941D";

const breakpoints = {
  tablet: 768,
  phone:  480,
};


const TabsContainer = styled.ul`
  display: flex;
  justify-content: center;
  list-style-type: none;
  border-bottom: 2px solid #ccc;

  li {
    margin-right: 15px;
    margin-bottom: 30px;
  }

  a {
    text-decoration: none;
    padding: 10px 10px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(props) => props.colors.cardBackground};
    color: ${(props) => props.colors.buttonBackground};
    transition: all 0.3s;
    font-weight: 600;

    &.selected {
      background-color: ${(props) => props.colors.buttonBackground};
      color: white;
      border-color: ${(props) => props.colors.buttonBackground};
    }

    &:not(.selected) {
      background-color: ${(props) => props.colors.titleText};
      color: ${(props) => props.colors.buttonBackground};
    }

    &:hover {
      background-color: ${TAB_HOVER_COLOR};
      border-color: ${TAB_HOVER_COLOR};
      color: white;
    }
  }

 @media (max-width: ${breakpoints.phone}px) {
    width: 500px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding: 10px;
    margin-bottom: 0;
`;

const DirectoryTabs = ({ colors, selectedTab, handleTabClick }) => {
  const tabs = [
    "Organization Search",
    "User Search"
  ];

  return (
    <TabsContainer colors={colors}>
      {tabs.map((tab) => (
        <li key={tab}>
          <a
            href="#"
            className={selectedTab === tab ? "selected" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        </li>
      ))}
    </TabsContainer>
  );
};

export default DirectoryTabs;
